/* eslint-disable jsx-a11y/anchor-is-valid, no-nested-ternary */

import Button from '@material-ui/core/Button'
import { withStyles } from '@material-ui/core/styles'
import cn from 'classnames'
import React from 'react'

import Icon from '../Icon'

const styles = theme => ({
  link: {
    textDecoration: 'none',
  },
  root: {
    height: '36px',
    padding: '0 2.25rem',
    '&.backButton': {
      padding: '0 .625rem 0 .375rem',
    },
  },
  contained: {
    padding: '0 2.25rem',
    '&.primary:disabled': {
      color: theme.colors.white,
      backgroundColor: theme.buttons.primaryButtonBg,
      borderColor: theme.buttons.primaryButtonColor,
    },
  },
  flat: {
    fontWeight: theme.typography.fontWeightNormal,
    border: '1px solid transparent',
    padding: '0 1.125rem',
  },
  outlined: {
    '&.primary': {
      borderColor: theme.palette.primary.main,
    },
    '&.secondary': {
      backgroundColor: theme.colors.white,
    },
  },
  disabled: {
    '&.custom': {
      opacity: 0.4,
    },
  },
  label: {
    '& .custom-icon': {
      display: 'flex',
    },
  },
})

const ButtonWithLink = ({
  backButton,
  backButtonLabel,
  buttoncolour,
  buttontextcolour,
  classes,
  className,
  color,
  label,
  variant,
  ...rest
}) => {
  const buttonClasses = {
    root: classes.root,
    label: classes.label,
    contained: classes.contained,
    outlined: classes.outlined,
    disabled: classes.disabled,
  }

  const customStyles = {
    backgroundColor: buttoncolour,
    color: buttontextcolour,
  }

  return (
    <Button
      color={color}
      variant={variant}
      classes={buttonClasses}
      className={cn(
        {
          backButton,
          custom: buttoncolour || buttontextcolour,
        },
        color,
        className
      )}
      style={customStyles}
      aria-label={label}
      {...rest}
    >
      {backButton && !backButtonLabel ? (
        <React.Fragment>
          <Icon iconName="Arrow_left" iconSize={22} /> Back
        </React.Fragment>
      ) : backButton ? (
        backButtonLabel
      ) : (
        label
      )}
    </Button>
  )
}

ButtonWithLink.defaultProps = {
  color: 'secondary',
  label: '',
  variant: 'text',
}

const ButtonWithLinkComponent = withStyles(styles)(ButtonWithLink)
ButtonWithLinkComponent.displayName = 'ButtonWithLink'
export default ButtonWithLinkComponent
